import { render } from "./Program05.vue?vue&type=template&id=4d4ec8e8"
import script from "./Program05.vue?vue&type=script&lang=js"
export * from "./Program05.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__